<template>
  <div class="loader-wrapper">
    <div class="loader"></div>
    <div class="message p-5" v-if="message">{{ message }}</div>
  </div>
</template>

<script>
export default {
  props: ["message"],
};
</script>

<style>
.loader-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 24px;
  z-index: 9999;
}
.loader {
  border: 7px solid rgb(38, 38, 39);
  border-radius: 50%;
  border-top: 7px solid #f3f3f3;
  width: 60px;
  height: 60px;
  -webkit-animation: spin 1s linear infinite;
  animation: spin 1s linear infinite;
}

@-webkit-keyframes spin {
  from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes spin {
  from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.loading-text {
  font-size: 18px;
  color: white;
  text-align: center;
}

.loading-parent {
  z-index: 9999;
  position: fixed;
  top: 0px;
  left: 0px;
  background: rgb(28, 28, 28);
}
</style>